import ReminderGroupTypes from 'owa-service/lib/contract/ReminderGroupTypes';
import { getUserMailboxInfo } from 'owa-client-ids';
import { lazyOpenCalendarReadForm } from 'owa-calendar-read-form-lifecycle';
import { onReminderClicked } from 'owa-header-app-notifications';
import { orchestrator } from 'satcheljs';

// TODO: VSO #88707 Separate module vs surface concerns in Calendar module
// Eventually should move to a more meaningful package, but unsure where

export default orchestrator(onReminderClicked, message => {
    // TODO-zorauf VSO #28930: See if this needs to be handled for groups as well?
    if (
        message.reminderType === ReminderGroupTypes.Calendar ||
        message.reminderType === ReminderGroupTypes.Birthdays
    ) {
        lazyOpenCalendarReadForm.importAndExecute({
            itemId: { Id: message.itemId, mailboxInfo: getUserMailboxInfo() },
            entrySource: 'Reminder',
            isDeeplink: true,
        });
    }
});
